import React from "react";
import { defineMessages } from "react-intl";
import { localizedChannel } from "../../../intl/shared-resources/channel.js";
import { localizedUserAccountStatus } from "../../../intl/shared-resources/userAccountStatus.js";
import { FilterGroupNew } from "../../../components/filter/FilterGroupNew.js";
import "moment-timezone";
import "../../../components/input/validation.js";
import "../../../components/input/DatePicker.js";
import "../../../components/input/DateRangePicker.js";
import "../../../components/input/StyledInput.js";
import "../../../components/input/FormInput.js";
import "../../../components/input/StyledFormInputHoc.js";
import "../../../components/input/DateSinglePicker.localize.js";
import "../../../components/input/hooks.js";
import "@mui/material";
import { DateRangeFilter } from "../../../components/filter/dateRangeFilter/DateRangeFilter.js";
import "../../../components/filter/date-filter/DateFilter.js";
import { TextInputWithDropdownFilter } from "../../../components/filter/TextFilterWithDropdown.js";
import "../../../components/filter/MultiStepFilterDrawer.js";
import "../../../components/filter/dateRangeFilter/MultiStepFilterDatePicker.js";
import { SelectFilter } from "../../../components/filter/SelectFilter.js";
import { TextFilterFixedWidth, TextFilterFullWidth } from "../../../components/filter/TextFilter.js";
import { ValueRangeFilter } from "../../../components/filter/valueRangeFilter/ValueRangeFilter.js";
import "../../../components/filter/dateRangeFilter/localized.js";
import "../../../components/filter/dateRangeFilter/DateRangeHistoricalFilter.js";
import "../../../components/filter/MultiStepFilterApplyButton.js";
import "../../../components/filter/MultiStepFilterInput.js";
import "../../../components/filter/MultiStepFilterHoc.js";
import "../../../components/select/Select.js";
import "../../../components/chip/ChipRenderer.js";
import "../../../components/select/selectStyle.js";
import "../../../components/select/MultiSelectFooter.js";
import "../../../components/select/MultiSelect.js";
import "../../../components/select/MultiSelectItem.js";
import "../../../components/select/SelectArrowIcon.js";
import "../../../components/select/VirtualizedMultiSelectOptionList.js";
import "../../../components/select/SingleSelect.js";
import "../../../components/select/MultiSelectWithExclude.js";
import "../../../components/select/MultiSelectTextCounterWithTooltip.js";
import "../../../components/filter/PhoneFilter.js";
import { UserAccountStatus, Channel } from "../../../contract/pam.js";
import "typesafe-actions";
import "rxjs";
import "rxjs/operators";
import "@opentelemetry/api";
import "../../../otel/TraceProvider.js";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "redux-observable";
import "../../../api/types.js";
import "immer";
import "@apollo/client/errors";
import "@apollo/client";
import "graphql";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "../../../redux-folder/async-action/action.js";
import "../../../redux-folder/error-handling/action.js";
import "../../../redux-folder/actions.js";
import "fast-deep-equal/es6";
import "redux";
import "../../../redux-folder/entity/epics.js";
import "normalizr";
import "../../../redux-folder/entity/EntityProvider.js";
import "../../../redux-folder/realtime/RealtimeNotification.js";
import "reselect";
import "react-redux";
import "react-router";
import "../../agent-profile/components/AgentAutocomplete.js";
import { AgentFilter } from "../../agent-profile/components/AgentFilter.js";
import "../../../auto-mapper/AutoMapperProvider.js";
import "@automapper/core";
import { AalFilter } from "../../bo-user-group/components/AalFilter.js";
import "../../brand-license/constants.js";
import { CountryFilter } from "../../country/components/CountryFilter.js";
import "../../brand-license/components/BrandProvider.js";
import "react-oidc-context";
import "oidc-client-ts";
import "../../../components/alerts/NoAccessInfoMessage.js";
import { LicenseSelect } from "../../brand-license/components/LicenseSelect.js";
import { BrandSelect } from "../../brand-license/components/BrandSelect.js";
import "../../../components/circle-box/CircleBoxWithText.js";
import "../../../components/label/EmptyLabel.js";
import "../../../components/label/LabelHoc.js";
import "../../../components/tooltip/Tooltip.js";
import "../../../components/tooltip/AutoAdjustedWidthTooltip.styles.js";
import "../../../components/tooltip/AutoAdjustedComplexTooltip.styles.js";
import "../../../components/tooltip/MultiLineAutoAdjustedWidthTooltip.js";
import "@mui/material/colors";
import "@mui/material/locale";
import "@mui/material/styles";
import "../../../style/hooks.js";
import "../../../components/circle-box/CircleBox.js";
import "../../../localization/MessageLocalizer.js";
import { useLocale } from "../../../localization/hooks.js";
import "../../../localization/LocaleProvider.js";
import "../../../localization/sharedResources.js";
import { UserAccountStatusTypeName, ChannelTypeName } from "../constants.js";
const localized = defineMessages({
  textFullFilter: {
    id: "UserProfileFilters_textFullFilter",
    defaultMessage: "All"
  },
  uid: {
    id: "UserProfileFilters_userId",
    defaultMessage: "Player ID"
  },
  agentId: {
    id: "UserProfileFilters_agentId",
    defaultMessage: "Agent ID"
  },
  username: {
    id: "UserProfileFilters_username",
    defaultMessage: "Username"
  },
  referrerId: {
    id: "UserProfileFilters_referrer",
    defaultMessage: "Referrer"
  },
  firstName: {
    id: "UserProfileFilters_firstName",
    defaultMessage: "First Name"
  },
  lastName: {
    id: "UserProfileFilters_lastName",
    defaultMessage: "Last Name"
  },
  phoneNumber: {
    id: "UserProfileFilters_phoneNumber",
    defaultMessage: "Phone number"
  },
  securityCaseId: {
    id: "UserProfileFilters_securityCaseId",
    defaultMessage: "Security Case ID"
  },
  tournamentsId: {
    id: "UserProfileFilters_tournamentsId",
    defaultMessage: "Tournaments ID"
  },
  nickname: {
    id: "UserProfileFilters_nickname",
    defaultMessage: "Nickname"
  },
  labels: {
    id: "UserProfileFilters_labels",
    defaultMessage: "Label"
  },
  email: {
    id: "UserProfileFilters_email",
    defaultMessage: "Email"
  },
  cashGamesId: {
    id: "UserProfileFilters_cashGamesId",
    defaultMessage: "Cash Game ID"
  },
  accountStatus: {
    id: "UserProfileFilters_accountStatus",
    defaultMessage: "Account Status"
  },
  registrationCountry: {
    id: "UserProfileFilters_registrationCountry",
    defaultMessage: "Registration Country"
  },
  registrationDate: {
    id: "UserProfileFilters_registrationDate",
    defaultMessage: "Registration Date Range"
  },
  country: {
    id: "UserProfileFilters_country",
    defaultMessage: "Country"
  },
  loginCountry: {
    id: "UserProfileFilters_loginCountry",
    defaultMessage: "Login Country"
  },
  casinoGgr: {
    id: "UserProfileFilters_casinoGgr",
    defaultMessage: "Casino GGR"
  },
  pokerGgr: {
    id: "UserProfileFilters_pokerGgr",
    defaultMessage: "Poker GGR"
  },
  sportsGgr: {
    id: "UserProfileFilters_sportsGgr",
    defaultMessage: "Sportsbook GGR"
  },
  depositTotal: {
    id: "UserProfileFilters_depositTotal",
    defaultMessage: "Total Deposits"
  },
  withdrawalTotal: {
    id: "UserProfileFilters_withdrawalTotal",
    defaultMessage: "Total Withdrawals"
  },
  marketingCode: {
    id: "UserProfileFilters_marketingCode",
    defaultMessage: "Marketing Code"
  },
  numberPlaceholder: {
    id: "UserProfileFilters_numberPlaceholder",
    defaultMessage: "For example, 123"
  },
  namePlaceholder: {
    id: "UserProfileFilters_namePlaceholder",
    defaultMessage: "For example, Antonio"
  },
  emailPlaceholder: {
    id: "UserProfileFilters_emailPlaceholder",
    defaultMessage: "For example, antonio@xyz.com"
  },
  countryPlaceholder: {
    id: "UserProfileFilters_countryPlaceholder",
    defaultMessage: "For example, Ireland"
  },
  channel: {
    id: "UserProfileFilters_channel",
    defaultMessage: "Channel"
  },
  nationalId: {
    id: "UserProfileFilters_nationalId",
    defaultMessage: "National ID"
  },
  personalReferralCode: {
    id: "UserProfileFilters_personalReferralCode",
    defaultMessage: "Referral Code"
  },
  brand: {
    id: "UserProfileFilters_brand",
    defaultMessage: "Brand"
  }
});
function UserProfileFilterTextFullWidth(props) {
  return /* @__PURE__ */ React.createElement(TextFilterFullWidth, { ...props, disallowSpecialCharacters: true });
}
function UserProfileFilterTextFixedWidth(props) {
  return /* @__PURE__ */ React.createElement(TextFilterFixedWidth, { ...props, disallowSpecialCharacters: true });
}
function UserProfileFilters({
  viewMode = "six-column-view",
  countryEntity,
  countryConfig,
  defaultPlayerId,
  isAgent,
  viewType,
  agentProfileEntity,
  mode = "update-on-submit",
  ...props
}) {
  const { locale } = useLocale();
  function getTextFilterPlaceholder(option) {
    const placeholderMapper = {
      uid: localized.numberPlaceholder,
      username: localized.namePlaceholder,
      email: localized.emailPlaceholder,
      referrerId: localized.numberPlaceholder,
      firstName: localized.namePlaceholder,
      lastName: localized.namePlaceholder,
      nickname: localized.namePlaceholder,
      labels: localized.numberPlaceholder,
      registrationCountry: localized.countryPlaceholder,
      loginCountry: localized.countryPlaceholder,
      marketingCode: localized.numberPlaceholder,
      networks_PKW: localized.numberPlaceholder,
      networks_BL: localized.numberPlaceholder,
      uid_un_fn_ln_em_ph_rmc: localized.numberPlaceholder,
      uid_un_nn_em_sc_nuid: localized.numberPlaceholder,
      uid_un_fn_ln_labels_em_ni_rmc_phone_r: localized.numberPlaceholder,
      uid_un_nn_em_l_sc_nuid_ref: localized.numberPlaceholder,
      uid_un_rmc_em: localized.numberPlaceholder,
      uid_username_nickname_referralCode: localized.numberPlaceholder,
      nationalId: localized.numberPlaceholder,
      boUserId: localized.numberPlaceholder,
      boUserId_uid: localized.numberPlaceholder,
      personalReferralCode: localized.numberPlaceholder
    };
    return placeholderMapper[option] ?? localized.numberPlaceholder;
  }
  const filters = [
    {
      filterName: "agentId_nickname_username_referralCode",
      modelField: "text",
      component: (props2) => /* @__PURE__ */ React.createElement(
        TextInputWithDropdownFilter,
        {
          options: [
            { label: localized.textFullFilter, value: "uid_username_nickname_referralCode" },
            { label: localized.agentId, value: "uid" },
            { label: localized.username, value: "username" },
            { label: localized.nickname, value: "nickname" },
            { label: localized.personalReferralCode, value: "personalReferralCode" }
          ],
          getInputPlaceholder: getTextFilterPlaceholder,
          width: "full",
          ...props2
        }
      )
    },
    {
      filterName: "uid_email_username_marketingCode",
      modelField: "text",
      component: (props2) => /* @__PURE__ */ React.createElement(
        TextInputWithDropdownFilter,
        {
          options: [
            { label: localized.textFullFilter, value: "uid_un_rmc_em" },
            { label: localized.uid, value: "uid" },
            { label: localized.username, value: "username" },
            { label: localized.email, value: "email" },
            { label: localized.marketingCode, value: "marketingCode" }
          ],
          getInputPlaceholder: getTextFilterPlaceholder,
          width: "full",
          ...props2
        }
      )
    },
    {
      filterName: "uid",
      modelField: "uid",
      component: (props2) => /* @__PURE__ */ React.createElement(UserProfileFilterTextFixedWidth, { ...props2, inputPlaceholder: localized.uid }),
      collapseOnMobile: false
    },
    {
      filterName: "uidWithPlaceholder",
      modelField: "uid",
      component: (props2) => /* @__PURE__ */ React.createElement(UserProfileFilterTextFullWidth, { ...props2, inputPlaceholder: localized.uid }),
      collapseOnMobile: false
    },
    {
      filterName: "username",
      modelField: "username",
      component: (props2) => /* @__PURE__ */ React.createElement(UserProfileFilterTextFullWidth, { ...props2, inputPlaceholder: localized.username }),
      collapseOnMobile: false
    },
    {
      filterName: "nickname",
      modelField: "nickname",
      component: (props2) => /* @__PURE__ */ React.createElement(UserProfileFilterTextFullWidth, { ...props2, inputPlaceholder: localized.nickname }),
      collapseOnMobile: false
    },
    {
      filterName: "labels",
      modelField: "labels",
      component: (props2) => /* @__PURE__ */ React.createElement(UserProfileFilterTextFullWidth, { ...props2, inputPlaceholder: localized.labels }),
      collapseOnMobile: false
    },
    {
      filterName: "email",
      modelField: "email",
      component: (props2) => /* @__PURE__ */ React.createElement(UserProfileFilterTextFullWidth, { ...props2, inputPlaceholder: localized.email }),
      collapseOnMobile: false
    },
    {
      filterName: "phone",
      modelField: "phone",
      component: (props2) => /* @__PURE__ */ React.createElement(UserProfileFilterTextFullWidth, { ...props2, inputPlaceholder: localized.phoneNumber }),
      collapseOnMobile: false
    },
    {
      filterName: "security_cases",
      modelField: "security_cases",
      component: (props2) => /* @__PURE__ */ React.createElement(UserProfileFilterTextFullWidth, { ...props2, inputPlaceholder: localized.securityCaseId }),
      collapseOnMobile: false
    },
    {
      filterName: "networks_PKW",
      modelField: "networks_PKW",
      component: (props2) => /* @__PURE__ */ React.createElement(UserProfileFilterTextFullWidth, { ...props2, inputPlaceholder: localized.cashGamesId }),
      collapseOnMobile: false
    },
    {
      filterName: "networks_BL",
      modelField: "networks_BL",
      component: (props2) => /* @__PURE__ */ React.createElement(UserProfileFilterTextFullWidth, { ...props2, inputPlaceholder: localized.tournamentsId }),
      collapseOnMobile: false
    },
    {
      filterName: "referrerId",
      modelField: "referrerId",
      component: (props2) => /* @__PURE__ */ React.createElement(UserProfileFilterTextFullWidth, { ...props2, inputPlaceholder: localized.referrerId }),
      collapseOnMobile: false
    },
    {
      filterName: "accountStatus",
      modelField: "accountStatus",
      component: (props2) => /* @__PURE__ */ React.createElement(
        SelectFilter,
        {
          label: localized.accountStatus,
          options: Object.values(UserAccountStatus).map(
            (s) => ({
              label: localizedUserAccountStatus[s],
              value: s
            })
          ),
          chipType: UserAccountStatusTypeName,
          multiple: true,
          ...props2
        }
      ),
      collapseOnMobile: false
    },
    {
      filterName: "firstName",
      modelField: "firstName",
      component: (props2) => /* @__PURE__ */ React.createElement(UserProfileFilterTextFullWidth, { ...props2, inputPlaceholder: localized.firstName }),
      collapseOnMobile: false
    },
    {
      filterName: "lastName",
      modelField: "lastName",
      component: (props2) => /* @__PURE__ */ React.createElement(UserProfileFilterTextFullWidth, { ...props2, inputPlaceholder: localized.lastName }),
      collapseOnMobile: false
    },
    {
      filterName: "registrationCountry",
      modelField: "registrationCountry",
      component: (props2) => /* @__PURE__ */ React.createElement(CountryFilter, { inputLabel: localized.registrationCountry, countryEntity, config: countryConfig, ...props2 }),
      collapseOnMobile: false
    },
    {
      filterName: "registrationCountryWithCountryPlaceholder",
      modelField: "registrationCountry",
      component: (props2) => /* @__PURE__ */ React.createElement(CountryFilter, { inputLabel: localized.country, countryEntity, config: countryConfig, ...props2 }),
      collapseOnMobile: false
    },
    {
      filterName: "loginCountry",
      modelField: "loginCountry",
      component: (props2) => /* @__PURE__ */ React.createElement(CountryFilter, { inputLabel: localized.loginCountry, countryEntity, config: countryConfig, ...props2 }),
      collapseOnMobile: false
    },
    {
      filterName: "registrationDate",
      modelField: "registrationDate",
      component: (props2) => /* @__PURE__ */ React.createElement(DateRangeFilter, { ...props2, placeholder: localized.registrationDate, width: "full", locale }),
      collapseOnMobile: false
    },
    {
      filterName: "casinoGgr",
      modelField: "casinoGgr",
      component: (props2) => {
        return /* @__PURE__ */ React.createElement(ValueRangeFilter, { ...props2, label: localized.casinoGgr, min: 0, hideEqualOperator: true });
      }
    },
    {
      filterName: "pokerGgr",
      modelField: "pokerGgr",
      component: (props2) => {
        return /* @__PURE__ */ React.createElement(ValueRangeFilter, { ...props2, label: localized.pokerGgr, min: 0, hideEqualOperator: true });
      }
    },
    {
      filterName: "sportsGgr",
      modelField: "sportsGgr",
      component: (props2) => {
        return /* @__PURE__ */ React.createElement(ValueRangeFilter, { ...props2, label: localized.sportsGgr, min: 0, hideEqualOperator: true });
      }
    },
    {
      filterName: "depositTotal",
      modelField: "depositTotal",
      component: (props2) => {
        return /* @__PURE__ */ React.createElement(ValueRangeFilter, { ...props2, label: localized.depositTotal, min: 0, hideEqualOperator: true });
      }
    },
    {
      filterName: "withdrawalTotal",
      modelField: "withdrawalTotal",
      component: (props2) => {
        return /* @__PURE__ */ React.createElement(ValueRangeFilter, { ...props2, label: localized.withdrawalTotal, min: 0, hideEqualOperator: true });
      }
    },
    {
      filterName: "marketingCode",
      modelField: "marketingCode",
      component: (props2) => /* @__PURE__ */ React.createElement(UserProfileFilterTextFullWidth, { ...props2, inputPlaceholder: localized.marketingCode }),
      collapseOnMobile: false
    },
    {
      filterName: "agent",
      modelField: "agent",
      component: (props2) => /* @__PURE__ */ React.createElement(
        AgentFilter,
        {
          defaultPlayerId,
          width: "full",
          viewType,
          withDownstream: true,
          agentProfileEntity,
          isTreeMode: isAgent,
          ...props2
        }
      ),
      collapseOnMobile: false
    },
    {
      filterName: "channel",
      modelField: "channel",
      component: (props2) => /* @__PURE__ */ React.createElement(
        SelectFilter,
        {
          label: localized.channel,
          options: Object.values(Channel).map(
            (s) => ({
              label: localizedChannel[s],
              value: s
            })
          ),
          chipType: ChannelTypeName,
          multiple: true,
          ...props2
        }
      ),
      collapseOnMobile: false
    },
    {
      filterName: "nationalId",
      modelField: "nationalId",
      component: (props2) => /* @__PURE__ */ React.createElement(UserProfileFilterTextFullWidth, { ...props2, inputPlaceholder: localized.nationalId }),
      collapseOnMobile: false
    },
    {
      filterName: "licenseType",
      modelField: "licenseType",
      component: (props2) => /* @__PURE__ */ React.createElement(LicenseSelect, { ...props2, multiple: true }),
      collapseOnMobile: false
    },
    {
      filterName: "aal",
      modelField: "aal",
      component: (props2) => /* @__PURE__ */ React.createElement(AalFilter, { ...props2, filterBy: "group_name" })
    },
    {
      filterName: "brand",
      modelField: "brand",
      component: BrandSelect,
      collapseOnMobile: false
    }
  ];
  return /* @__PURE__ */ React.createElement(FilterGroupNew, { mode, viewMode, allFilters: filters, ...props });
}
export {
  UserProfileFilters
};
//# sourceMappingURL=Filters.js.map
